import { createDownloadsOverTimeChart } from "./over_time_chart";
import { downloadChartCsv } from "../../shared/csv_download";
import { wireDownloadsPicker } from "../../date_pickers/downloads_over_time_datepicker";
// Ensure EpisodeBreakdownTable is registered for the downloads page
import "./episode_breakdown_table";

// Alpine orchestration: composes chart + date-picker modules
document.addEventListener('alpine:init', () => {
  Alpine.data('ShowDownloadsOverTime', () => ({
    chartApi: null,
    pickerApi: null,
    loading: false,
    lastParams: { chart_type: 'show_downloads_over_time', date_range: '7d' },
    init() {
      const el = this.$el ? this.$el.querySelector('#DownloadsOverTimeChart') : document.getElementById('DownloadsOverTimeChart');
      if (!el) return;
      const apiUrl = (el && el.dataset && el.dataset.apiUrl) ? el.dataset.apiUrl : '/analytics/chart';

      // Chart API
      this.chartApi = createDownloadsOverTimeChart(el, apiUrl);

      // Picker wiring
      const onChange = async (payload) => {
        this.loading = true;
        try {
          if (payload?.type === 'preset') {
            await this.chartApi.loadPreset(payload.days);
            this.lastParams = { chart_type: 'show_downloads_over_time', date_range: `${payload.days}d` };
          } else if (payload?.type === 'custom') {
            await this.chartApi.loadCustom(payload.from, payload.to);
            this.lastParams = { chart_type: 'show_downloads_over_time', date_range: 'custom', start_date: payload.from, end_date: payload.to };
          }
        } catch (e) {
          console.error('downloads: change handler error', e);
        } finally {
          this.loading = false;
        }
      };
      this.pickerApi = wireDownloadsPicker(this.$el || document, onChange);

      // Initial load (7 days) with local loading overlay
      this.loading = true;
      this.chartApi
        .loadPreset(7)
        .catch(e => console.error('downloads: initial load error', e))
        .finally(() => { this.loading = false; });
      // Reflect active 7-day preset in UI
      try { this.pickerApi && this.pickerApi.setActive && this.pickerApi.setActive(7); } catch (_) {}

      // CSV download button
      const dlBtn = (this.$el || document).querySelector('#prefix-downloads-csv');
      if (dlBtn) {
        dlBtn.addEventListener('click', async () => {
          try {
            const params = new URLSearchParams();
            Object.entries(this.lastParams || {}).forEach(([k, v]) => params.append(k, v));
            await downloadChartCsv({
              endpoint: apiUrl,
              params,
              filename: 'show_downloads_over_time.csv',
              columns: [
                { key: 'created_at_date', label: 'Date' },
                { key: 'total_downloads', label: 'Downloads' }
              ],
              dataPath: 'download_data'
            });
          } catch (e) {
            console.error('csv download error', e);
          }
        });
      }

      // Cleanup on Turbo cache
      window.addEventListener('turbo:before-cache', () => this.destroy());

      // Clear button wiring for Show Downloads Over Time
      try {
        const input = (this.$el || document).querySelector('#download-range');
        const clearBtn = (this.$el || document).querySelector('#downloads-clear');
        const fromEl = (this.$el || document).querySelector('#downloads_from');
        const toEl = (this.$el || document).querySelector('#downloads_to');

        const syncClearVisibility = () => {
          try {
            if (!clearBtn || !input) return;
            const show = Boolean(input.value && input.value.trim().length > 0);
            if (show) { clearBtn.classList.remove('hidden'); } else { clearBtn.classList.add('hidden'); }
          } catch (_) {}
        };
        const handleClear = () => {
          try {
            if (input) input.value = '';
            if (fromEl) fromEl.value = '';
            if (toEl) toEl.value = '';
            // Restore default view to 7 days via the picker API
            try { this.pickerApi && this.pickerApi.setPreset && this.pickerApi.setPreset(7); } catch (_) {}
            syncClearVisibility();
          } catch (_) {}
        };
        if (input) {
          input.addEventListener('input', syncClearVisibility);
          input.addEventListener('change', syncClearVisibility);
          setTimeout(syncClearVisibility, 0);
        }
        if (clearBtn) clearBtn.addEventListener('click', handleClear);
      } catch (_) {}
    },

    destroy() {
      try { this.chartApi && this.chartApi.destroy && this.chartApi.destroy(); } catch (_) {}
      try { this.pickerApi && this.pickerApi.destroy && this.pickerApi.destroy(); } catch (_) {}
      this.chartApi = null;
      this.pickerApi = null;
    }
  }));
});
